import { render, staticRenderFns } from "./NewsSubscriptionModal.vue?vue&type=template&id=3bff789e&scoped=true"
import script from "./NewsSubscriptionModal.vue?vue&type=script&lang=js"
export * from "./NewsSubscriptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff789e",
  null
  
)

export default component.exports